import { HttpErrorResponse } from '@angular/common/http';
import { Action, createAction, props } from '@ngrx/store';
import { AnalyticsReportRequest } from '../models/analytics-reports/analyticsReportRequest.model';
import { Blocked } from '../models/analytics-reports/blocked.model';
import { GoodsKPIReport } from '../models/analytics-reports/goods.model';
import { Sessions } from '../models/analytics-reports/session.model';
import { Users } from '../models/analytics-reports/users.model';
import { Views } from '../models/analytics-reports/views.model';

type reportResponse = Blocked | GoodsKPIReport | Users[] | Views | Sessions;

export const getReport = createAction('[Admin] getReport', props<{ payload: AnalyticsReportRequest }>());

export const onGetReportSuccessfully = createAction(
    '[Admin Report] getReport successfully',
    props<{ payload: reportResponse }>(),
);

export const onGetReportFailed = createAction(
    '[Admin Report] getReport failed',
    props<{ payload: HttpErrorResponse }>(),
);

export interface ActionWithPayload<T> extends Action {
    payload: T;
}
